import {searchCategoriesByKey} from "../features/search/search-categories";
import {SearchFilter} from "../features/search/search-types";

export const searchAndFilter = <T>(
  list: T[],
  toSearchString: (item: T) => string,
  searchTerm: string | null
): T[] => {
  if (!searchTerm) return list;
  const searchTermLower = searchTerm.toLowerCase();
  const sameCasePrefixBucket: T[] = [];
  const prefixBucket: T[] = [];
  const matchBucket: T[] = [];
  for (const el of list) {
    const term = toSearchString(el);
    if (term.startsWith(searchTerm)) {
      sameCasePrefixBucket.push(el);
    } else {
      const lc = term.toLowerCase();
      if (lc.startsWith(searchTermLower)) {
        prefixBucket.push(el);
      } else if (lc.includes(searchTermLower)) {
        matchBucket.push(el);
      }
    }
  }
  return [...sameCasePrefixBucket, ...prefixBucket, ...matchBucket];
};

const filterToKey = (f: SearchFilter) =>
  `${f.category}-${searchCategoriesByKey[f.category].valueToKey(f.value)}`;

export const filtersAreEqual = (s1: SearchFilter[], s2: SearchFilter[]) => {
  if (s1.length !== s2.length) return false;
  const s1Set = new Set(s1.map(filterToKey));
  return s2.every((s) => s1Set.has(filterToKey(s)));
};

export const containsFilter = (target: SearchFilter[], list: SearchFilter[]) => {
  if (list.length < target.length) return false;
  const keys = new Set(target.map(filterToKey));
  for (const filter of list) {
    keys.delete(filterToKey(filter));
    if (keys.size === 0) return true;
  }
  return false;
};

export const removeFilters = (target: SearchFilter[], list: SearchFilter[]) => {
  const keys = new Set(target.map(filterToKey));
  return list.filter((f) => !keys.has(filterToKey(f)));
};
